import { DataGridProps, DataGrid as MuiDataGrid } from "@mui/x-data-grid";
import { CustomPagination } from "src/components/CustomPagination";
import LoadingDialog from "src/components/LoadingDialog";
import { NoRowsOverlay } from "src/components/NoRowsOverlay";
import SearchFirstDataGridOverlay from "src/components/SearchFirstDataGridOverlay";
import { dataGridDefaults } from "src/utils/constant";
import { usePageConfigProviderContext } from "..";

const DataGrid = (props: DataGridProps) => {
  const {
    list,
    page,
    isLoading,
    shouldClickBeforeInitFetch,
    isSearchButtonClicked,
    onPageChange,
  } = usePageConfigProviderContext();

  if (isLoading) return <LoadingDialog forceOpen />;

  return (
    <MuiDataGrid
      {...dataGridDefaults}
      rowCount={list.count}
      page={page}
      onPageChange={onPageChange}
      components={{
        NoRowsOverlay:
          shouldClickBeforeInitFetch && !isSearchButtonClicked
            ? SearchFirstDataGridOverlay
            : NoRowsOverlay,
        Footer: CustomPagination,
      }}
      componentsProps={{
        footer: { totalRecords: list.count },
      }}
      {...props}
    />
  );
};
export default DataGrid;
